<template>
  <div class="enterprise-list-page enterprise-list-page--catalog enterprise-list-page--medicine-list">
    <!-- Header Card -->
        <PageHeader icon="fas fa-pills">
      <template #title>
        Daftar Obat dan Alkes {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola katalog obat, sediaan farmasi, dan alat kesehatan habis pakai
      </template>
      <template #actions>
        <b-button class="btn btn-light-primary font-weight-bold mr-2" @click="$router.push('/medicine/category')" v-if="btn">
          <i class="fas fa-tags"></i><span>Kategori</span>
        </b-button>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/medicine/add')"
                v-if="btn">
                <i class="fas fa-plus"></i>
                <span>Tambah Obat</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table purpose = 'master' :isAbjad ="true" />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Card from "@/view/content/Card.vue";
import Table from '@/component/medicine/Table.vue'

export default {

  name: "List",

  components: {
    Card,
    Table
  },

  data() {
    return {
      btn: false,
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    }
  },

  methods: {

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)
      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "9002") {
          this.btn = true
        }
      }
    },

  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Obat dan Alkes" },
      { title: "Daftar Obat dan Alkes" },
    ])
    this.setActiveButton()
  },

}

</script>
